import { z } from 'zod';
import { BaseEstimateSchema } from '../../base/base.js';
import { EstimateOpenApiSchema } from '../../base/estimate.js';
export const GetEstimateApiSchema = {
    params: BaseEstimateSchema.pick({ entityId: true, estimateId: true }),
    response: z.object({ estimate: EstimateOpenApiSchema }),
};
export const GetEstimatePathSchema = GetEstimateApiSchema.params;
export const GetEstimateRequestSchema = GetEstimatePathSchema;
export const GetEstimateResponseSchema = GetEstimateApiSchema.response;
